
import Vue from 'vue';
import * as QueryStore from '@/store/search/query';

export default Vue.extend({
	computed: {
		pattern: QueryStore.get.patternSummary,
		filters: QueryStore.get.filterSummary,
		summary(): string {
			if (!this.pattern && !this.filters) {
				return this.$t('results.querySummary.allDocuments') as string ;
			}

			let ret = '';
			if (this.pattern) {
				ret += this.pattern + ' ' + this.$t('results.querySummary.within') + ' ';
			}
			if (this.filters) {
				ret += this.$t('results.querySummary.documentsWhere') + ' ' + this.filters;
			} else {
				ret += this.$t('results.querySummary.allDocuments');
			}

			return ret;
		}
	},
});
